import { observable } from "mobx";
/*
    Custom Map to handle product specific requirements, where we need to insert every new Entity on top of the existing ones.
    Also to support replacing of existing Entity with new one and keep its sorting order.
*/
export class SortedMap {
    constructor(entries = []) {
        this.delete = (key) => this.map.delete(key);
        this.map = observable.map(entries.map(([k, v], sortOrder) => [k, Object.assign(Object.assign({}, v), { sortOrder })]));
        this.insertIndex = 0;
    }
    values() {
        return this.map.values();
    }
    sortedValues() {
        return [...this.map.values()]
            .sort((a, b) => a.sortOrder - b.sortOrder);
    }
    get(key) {
        return this.map.get(key);
    }
    insertOrReplace(key, replaceKey, value) {
        if (!replaceKey) {
            this.insert(key, value);
            return;
        }
        const oldEntry = this.map.get(replaceKey);
        if (oldEntry) {
            this.map.delete(replaceKey);
            this.insert(key, value, oldEntry.sortOrder);
        }
        else {
            this.insert(key, value);
        }
    }
    insert(key, value, sortOrder) {
        this.map.set(key, Object.assign(Object.assign({}, value), { sortOrder: sortOrder || --this.insertIndex }));
    }
}
//# sourceMappingURL=SortedMap.js.map